import React from 'react';
import styles from './CareRecipientListScopeByResponsibleUserField.module.scss';
import {
  ToggleField,
  ToggleFieldProps,
} from '../../components/field/ToggleField';

export function CareRecipientListScopeByResponsibleUserField(
  props: ToggleFieldProps,
) {
  return (
    <div className={styles.container}>
      <ToggleField {...props}>担当外の利用者を表示</ToggleField>
    </div>
  );
}
